import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["variables"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import { rebuildButtonAction, runTemplateOnInputs } from './utils';

/**
 * HOC that'll run template replacement on `MessageProps` fields of spotlight
 * messages and render the wrapped component.
 *
 * If any of the replacements fail with missing variables the component isn't
 * rendered and null is returned.
 *
 * The returned wrapped component accepts a `variables=` property which should
 * be a map of key to string value.
 *
 * This property isn't forwarded to the wrapped component
 *
 * @param TargetComponent<Props>
 * @returns {Component<Props & VariableProps>}
 */
export default function withVariables(TargetComponent) {
  // eslint-disable-next-line @repo/internal/react/no-class-components
  var WithVariables = /*#__PURE__*/function (_Component) {
    _inherits(WithVariables, _Component);
    var _super = _createSuper(WithVariables);
    function WithVariables() {
      _classCallCheck(this, WithVariables);
      return _super.apply(this, arguments);
    }
    _createClass(WithVariables, [{
      key: "render",
      value: function render() {
        var props = runMessagePropsReplacement(this.props);
        if (!props) {
          return null;
        }
        return /*#__PURE__*/React.createElement(TargetComponent, props);
      }
    }]);
    return WithVariables;
  }(Component);
  _defineProperty(WithVariables, "displayName", "".concat(TargetComponent.displayName || TargetComponent.name || '', "WithEPVariables"));
  return WithVariables;
}

/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */
function runMessagePropsReplacement(props) {
  var variables = props.variables,
    otherProps = _objectWithoutProperties(props, _excluded);
  var title = props.title,
    body = props.body,
    primaryText = props.primaryText,
    primaryAction = props.primaryAction,
    secondaryText = props.secondaryText,
    secondaryAction = props.secondaryAction;
  var inputs = {
    title: title,
    body: body,
    primaryText: primaryText,
    primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
    secondaryText: secondaryText,
    secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
  };
  var replacedInputs = runTemplateOnInputs(variables || {}, inputs);
  if (!replacedInputs) {
    return null;
  }
  var outputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    title: replacedInputs.title,
    body: replacedInputs.body,
    primaryText: replacedInputs.primaryText,
    secondaryText: replacedInputs.secondaryText
  });
  if (primaryAction) {
    outputProps.primaryAction = rebuildButtonAction(replacedInputs.primaryActionUrl, primaryAction);
  }
  if (secondaryAction) {
    outputProps.secondaryAction = rebuildButtonAction(replacedInputs.secondaryActionUrl, secondaryAction);
  }
  return outputProps;
}